import { ArrowRightIcon, BeakerIcon } from '@heroicons/react/24/outline'
import { Button } from '@duck/ui'
import { LocalizedLink as Link } from '@/components/LocalizedLink'
import { useTar } from '@/modules/i18n/useTar'
import { trackMarketing } from '@/modules/marketingAnalytics'
import { Logo } from '../Misc/Logo'

export const HomePageManifestoTeaser = () => {
  const { t } = useTar()

  return (
    <section
      className="relative isolate overflow-hidden border-y border-border py-14 md:py-20"
      aria-labelledby="manifesto-teaser-heading"
    >
      <BeakerIcon
        aria-hidden
        className="pointer-events-none absolute -end-12 -top-10 h-72 w-72 text-accent/[0.13] rotate-12 select-none"
      />
      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 items-center">
        <div className="space-y-5 text-start">
          <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
            {t('manifesto.kicker')}
          </p>
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-accent/10 ring-1 ring-accent/20">
              <Logo short className="text-2xl" />
            </div>
            <h2
              id="manifesto-teaser-heading"
              className="text-3xl md:text-4xl font-bold tracking-tight text-foreground"
            >
              {t('manifesto.title')}
            </h2>
          </div>
          <p className="text-muted-foreground text-lg max-w-md">
            {t('manifesto.subtitle')}
          </p>
        </div>
        <div className="flex justify-center md:justify-end">
          <Button
            asChild
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent hover:bg-accent/80 text-foreground text-lg font-medium rounded-lg transition-colors duration-200"
          >
            <Link
              to="/about"
              hash="manifesto"
              onClick={() => trackMarketing('home:manifesto_teaser:cta_click')}
            >
              <span>{t('home.manifestoTeaser.cta')}</span>
              <ArrowRightIcon className="w-5 h-5 rtl:rotate-180" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  )
}
